import { observable } from 'mobx'

import { z } from '@authy/lib-common/utils/zod'
import { client, RouterInput } from '@authy/lib-client/trpc'
import { ApplicationTypeSchema } from '@authy/lib-common/entities'

import { appState } from '@/appState'

type SortType = NonNullable<RouterInput['applications']['listApplications']['sort']>

export const SearchSchema = z.object({
    sort: z
        .string()
        .transform((val) => val as Extract<keyof SortType, string>)
        .optional()
        .default('name'),
    sortBy: z.enum(['asc', 'desc']).optional().default('asc'),
    searchTerm: z.string().optional(),
    type: z.union([z.literal(true), ApplicationTypeSchema]).default(true),
    party: z.enum(['first', 'third', 'both']).optional().default('both'),
})

export type Search = z.infer<typeof SearchSchema>

export const pageSize = 50

export const listApplications = async (search: Search, offset: number, abortController?: AbortController) => {
    const result = await client.applications.listApplications.query(
        {
            tenantId: appState.tenant!._id.toString(),
            searchTerm: search.searchTerm,
            types: search.type !== true ? [search.type] : undefined,
            party: search.party,
            sort: {
                [search.sort]: search.sortBy,
            },
            offset,
            limit: pageSize,
            returnCount: offset === 0,
        },
        { signal: abortController?.signal }
    )

    return observable(result)
}
